/* unplugin-vue-components disabled */import script from "./SkillsNode.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillsNode.vue?vue&type=script&setup=true&lang=js"

import "./SkillsNode.vue?vue&type=style&index=0&id=64c268f8&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64c268f8"]])

export default __exports__